import { toast } from "sonner";

// « Pare-feu paiement »: queue position while the server holds a payment action, retry prompt on high load.
export const PAY_RE = /^\/dev\/billing\/(checkout|custom|plan|renewal|prepaid\/checkout|cart\/checkout|employees|unsubscribe|resubscribe|business-plans\/[^/]+\/(unsubscribe|resubscribe))$/;
export const PAY_BUSY = /^Forte affluence/;

const TXT = {
  fr: ["Préparation du paiement… vous êtes n°{n}", "Forte affluence, réessayez dans une minute", "Réessayer"],
  en: ["Preparing payment… you are no. {n}", "High demand, please try again in a minute", "Retry"],
  es: ["Preparando el pago… usted es el n.º {n}", "Mucha afluencia, inténtelo de nuevo en un minuto", "Reintentar"],
  pt: ["A preparar o pagamento… é o n.º {n}", "Grande afluência, tente novamente dentro de um minuto", "Tentar novamente"],
  de: ["Zahlung wird vorbereitet… Sie sind Nr. {n}", "Hoher Andrang, bitte in einer Minute erneut versuchen", "Erneut versuchen"],
  it: ["Preparazione del pagamento… sei il n. {n}", "Grande affluenza, riprova tra un minuto", "Riprova"],
  ar: ["جارٍ تحضير الدفع… أنت رقم {n}", "ازدحام كبير، أعد المحاولة بعد دقيقة", "إعادة المحاولة"],
  zh: ["正在准备付款……您排在第 {n} 位", "当前访问量大，请一分钟后重试", "重试"],
  hi: ["भुगतान तैयार हो रहा है… आप क्रमांक {n} पर हैं", "बहुत भीड़ है, एक मिनट बाद फिर कोशिश करें", "फिर कोशिश करें"],
  ru: ["Подготовка оплаты… вы № {n}", "Высокая нагрузка, повторите попытку через минуту", "Повторить"],
};
const txt = () => TXT[(document.documentElement.lang || "").slice(0, 2)] || TXT[localStorage.getItem("fmo_lang")] || TXT.fr;
const ticketId = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export function payRequest(config) {
  if ((config.method || "get").toLowerCase() === "get" || !PAY_RE.test(config.url || "") || config.__payTicket) return config;
  const ticket = ticketId();
  config.__payTicket = ticket;
  config.retry = false;
  config.headers["X-Pay-Ticket"] = ticket;
  return config;
}

// Polls the position only once the action is visibly waiting (empty queue = immediate, no toast at all).
export function payWatch(api, config) {
  const ticket = config.__payTicket;
  if (!ticket) return () => {};
  let stop = false;
  let shown = false;
  const tick = async () => {
    if (stop) return;
    try {
      const { data } = await api.get(`/pay/queue/${ticket}`, { retry: false });
      if (!stop && data.position) {
        shown = true;
        toast.loading(txt()[0].replace("{n}", data.position), { id: `pay-${ticket}`, duration: Infinity });
      }
    } catch {
      /* position is cosmetic */
    }
    if (!stop) setTimeout(tick, 1000);
  };
  const first = setTimeout(tick, 600);
  return () => {
    stop = true;
    clearTimeout(first);
    if (shown) toast.dismiss(`pay-${ticket}`);
  };
}

// High load after 60 s: keep the caller waiting on a retry prompt; dismiss = original error.
export function payBusy(api, err) {
  const cfg = err.config;
  return new Promise((resolve, reject) => {
    let settled = false;
    const give = (fn) => (v) => {
      if (!settled) {
        settled = true;
        fn(v);
      }
    };
    toast.error(txt()[1], {
      id: `pay-busy-${cfg.__payTicket}`,
      duration: 60000,
      action: {
        label: txt()[2],
        onClick: () => {
          settled = true;
          delete cfg.__payTicket;
          api.request(cfg).then(resolve, reject);
        },
      },
      onDismiss: () => give(reject)(err),
      onAutoClose: () => give(reject)(err),
    });
  });
}
